export default __webpack_public_path__ + "static/media/briones-cow-crop.f01ed052.jpg";